import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeliveryTruck3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "delivery-truck-3" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 6,
			cy: 19.5,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 18.75,
			cy: 19.5,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.5,15H23.25v3a1.5,1.5,0,0,1-1.5,1.5h-1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 10.5,
			y1: 19.5,
			x2: 17.25,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 16.5,
			x2: 2.707,
			y2: 16.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.5,19.5H2.25A1.5,1.5,0,0,1,.75,18V13.765a1.5,1.5,0,0,1,.943-1.392L4.5,11.25,5.25,6H10.5V19.5h-3"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.5,
			y1: 11.25,
			x2: 10.5,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.5,3H22.25a1,1,0,0,1,1,1V15a0,0,0,0,1,0,0H10.5a0,0,0,0,1,0,0V3a0,0,0,0,1,0,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.75,3H10.5a0,0,0,0,1,0,0V6a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0V4A1,1,0,0,1,4.75,3Z"
		})
	]
});
export default SvgDeliveryTruck3;
